import { render, staticRenderFns } from "./PeakFreqVibBl.vue?vue&type=template&id=aeea6f06&scoped=true&"
import script from "./PeakFreqVibBl.vue?vue&type=script&lang=js&"
export * from "./PeakFreqVibBl.vue?vue&type=script&lang=js&"
import style0 from "./PeakFreqVibBl.vue?vue&type=style&index=0&id=aeea6f06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeea6f06",
  null
  
)

/* custom blocks */
import block0 from "./PeakFreqVibBl.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports